// extracted by mini-css-extract-plugin
export default {"form":"Comment_form__2qYB4"};